import Screen from '@screen';
import styled from 'styled-components';

const DetailAccessibilityBottomContainer = styled.div<React.CSSProperties>`
  margin-top: ${Screen.widthRatio * 22}px;
`;

export default DetailAccessibilityBottomContainer;
